// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style {
  width: 349px;
  height: 251px;
  top: 399px;
  left: 15px;
  padding: 10px;
  gap: 23px;
  background-color: #FAFAFA;
}

.vector {
  color: #222222;
  display: flex;
  align-items: center;
  justify-content: center;
}

.h1-text {
  font-family: Cambria, Cochin, Georgia, Times, "Times New Roman", serif;
  line-height: 48px;
  align-items: center;
  text-align: center;
  justify-content: center;
  font-weight: 600;
  font-size: 21px;
}

.para {
  color: rgba(0, 0, 0, 0.6);
  font-size: 18px;
  text-align: center;
  line-height: 38px;
}

.retry {
  display: flex;
  margin-top: 16px;
  line-height: 42px;
  align-items: center;
  justify-content: center;
}

.internet-backOverlay {
  width: 75%;
  height: 180px;
  top: 418px;
  left: 26px;
  border-radius: 8px;
  border: 1px solid #DEE2E6;
  padding: 36px 40px 36px 40px;
  gap: 24px;
  background-color: #FFFFFF;
}

.overlay-div {
  margin-top: 22px;
  width: 321px;
  height: 57px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.overlay-div h1 {
  font-size: 27px;
  font-weight: 600;
  line-height: 24.2px;
}

.overlay-div p {
  font-size: 18px;
  line-height: 32px;
  font-weight: 400px;
  color: rgba(84, 89, 94, 0.6);
}

.overlay-button {
  display: flex;
  margin-top: 42px;
  align-items: center;
  text-align: center;
  justify-content: center;
  width: 100%;
}

.prompt {
  background-color: rgba(217, 217, 217, 0.3803921569) !important;
  opacity: 38%;
  z-index: 2000;
}

.show-button {
  z-index: 2500;
  font-size: larger;
}`, "",{"version":3,"sources":["webpack://./styles.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,aAAA;EACA,UAAA;EACA,UAAA;EACA,aAAA;EACA,SAAA;EACA,yBAAA;AACJ;;AAOA;EACI,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAJJ;;AAOA;EAII,sEAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;AAPJ;;AAUA;EACI,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AAPJ;;AASA;EACI,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;AANJ;;AAYA;EACK,UAAA;EACA,aAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;EACA,4BAAA;EACA,SAAA;EACA,yBAAA;AATL;;AAYA;EACI,gBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACC,uBAAA;EACA,mBAAA;EACA,sBAAA;AATL;;AAWA;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AARJ;;AAYA;EACI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,4BAAA;AATJ;;AAYA;EACI,aAAA;EACA,gBAAA;EAEA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,WAAA;AAVJ;;AAYA;EACI,8DAAA;EACA,YAAA;EACA,aAAA;AATJ;;AAYA;EACI,aAAA;EACA,iBAAA;AATJ","sourcesContent":[".style {\n  width: 349px;\n  height: 251px;\n  top: 399px;\n  left: 15px;\n  padding: 10px;\n  gap: 23px;\n  background-color: #FAFAFA;\n}\n\n.vector {\n  color: #222222;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.h1-text {\n  font-family: Cambria, Cochin, Georgia, Times, \"Times New Roman\", serif;\n  line-height: 48px;\n  align-items: center;\n  text-align: center;\n  justify-content: center;\n  font-weight: 600;\n  font-size: 21px;\n}\n\n.para {\n  color: rgba(0, 0, 0, 0.6);\n  font-size: 18px;\n  text-align: center;\n  line-height: 38px;\n}\n\n.retry {\n  display: flex;\n  margin-top: 16px;\n  line-height: 42px;\n  align-items: center;\n  justify-content: center;\n}\n\n.internet-backOverlay {\n  width: 75%;\n  height: 180px;\n  top: 418px;\n  left: 26px;\n  border-radius: 8px;\n  border: 1px solid #DEE2E6;\n  padding: 36px 40px 36px 40px;\n  gap: 24px;\n  background-color: #FFFFFF;\n}\n\n.overlay-div {\n  margin-top: 22px;\n  width: 321px;\n  height: 57px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.overlay-div h1 {\n  font-size: 27px;\n  font-weight: 600;\n  line-height: 24.2px;\n}\n\n.overlay-div p {\n  font-size: 18px;\n  line-height: 32px;\n  font-weight: 400px;\n  color: rgba(84, 89, 94, 0.6);\n}\n\n.overlay-button {\n  display: flex;\n  margin-top: 42px;\n  align-items: center;\n  text-align: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.prompt {\n  background-color: rgba(217, 217, 217, 0.3803921569) !important;\n  opacity: 38%;\n  z-index: 2000;\n}\n\n.show-button {\n  z-index: 2500;\n  font-size: larger;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
